import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { ENVIRONMENT_NAME } from '../../config/api';

interface ProtectedRouteProps {
    children?: React.ReactNode;
    redirectPath?: string;
    allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    redirectPath = '/customer/login',
    allowedRoles
}) => {
    const { isAuthenticated, user } = useAuthStore();
    const location = useLocation();

    // UI Page Test bypass: ?testView=shell renders the component shell
    // without auth, so the test harness can verify the page renders.
    // Only enabled in non-production environments.
    if (ENVIRONMENT_NAME !== 'production') {
        const params = new URLSearchParams(location.search);
        if (params.get('testView') === 'shell') {
            return children ? <>{children}</> : <Outlet />;
        }
    }

    if (!isAuthenticated) {
        // Redirect to the login page, but save the current location
        return <Navigate to={redirectPath} state={{ from: location }} replace />;
    }

    // Check if user has required role
    if (allowedRoles && user && !allowedRoles.includes(user.role)) {
        return <Navigate to="/customer/dashboard" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;